module.exports = __webpack_public_path__ + "img/paizhao.0dd49cec.png";